module.exports = __webpack_public_path__ + "static/media/banniereSpecimenLogo.a7a0730e.png";